export default "<div>\n    <div data-bind=\"component: { name: 'tax-forms-list'}\"></div>\n</div>";